import React, { Component } from 'react';
import { Button } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Script from 'react-load-script'
import styled, { createGlobalStyle } from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
`

class Editor extends Component {
    render() {
        let {
            props: {
                minHeight = 500,
                style = {}
            }
        } = this

        return (
            <div style={{
                flex: 1,
                display: 'flex',
                minHeight: minHeight,
                height: '70vh'
            }}>
                <Script
                    url="https://editor.unlayer.com/embed.js?1"
                    onLoad={this.props.unlayerReady}
                />

                <div
                    id={this.props.id}
                    style={{ ...style, flex: 1 }}
                />
            </div>
        )
    }
}


class EmailBuilder extends Component {

    render() {
        return (
            <React.Fragment>

                <Container>
                    <Editor
                        id="editor"
                        unlayerReady={this.unlayerReady}
                    />

                    <div className="mt-4">
                        <div className="float-right">
                            <Button className="mr-2" onClick={this.props.onClose} color="warning"><FontAwesomeIcon icon="reply" className="mr-2" />Torna</Button>
                            <Button className="mr-2" onClick={this.loadTemplate} color="primary"><FontAwesomeIcon icon="file-download" className="mr-2" />Carica Template di default</Button>
                            {/* <Button className="mr-2" onClick={this.saveTemplate} color="first"><FontAwesomeIcon icon="file-upload" className="mr-2" />Salva come Template</Button> */}
                            <Button className="mr-2" onClick={this.onSave} color="success"><FontAwesomeIcon icon="check" className="mr-2" />Salva Modello</Button>
                        </div>
                    </div>

                </Container>
            </React.Fragment>
        )
    }

    // onLoad = () => {
    //     if (this.props.initialValue) {
    //         this.editor.loadDesign(this.props.initialValue)
    //     }

    // }

    onSave = () => {
        this.exportHtml(data => {
            const { design, html } = data;
            //console.log('exportHtml', html);
            this.props.onSave(design, html);
        })
    }


    unlayerReady = (id) => {
        const options = (this.props.options || { locale: "it" })

        if (this.props.projectId) {
            options.projectId = this.props.projectId;
        }

        if (this.props.templateId) {
            options.templateId = this.props.templateId;
        }

        if (this.props.tools) {
            options.tools = this.props.tools;
        }

        if (this.props.appearance) {
            options.appearance = this.props.appearance;
        }

        if (this.props.locale) {
            options.locale = this.props.locale;
        }

        unlayer.init({
            ...options,
            id: 'editor',
            //3538
            projectId: this.props.projectId,
            displayMode: 'email',
            mergeTags: {
                cliente: {
                    name: "Cliente",
                    mergeTags: {
                        name: {
                            name: "Denominazione",
                            value: "{{customer.name}}"
                        },
                        email: {
                            name: "Email",
                            value: "{{customer.email}}"
                        },
                    }
                },
                indirizzo: {
                    name: "Indirizzo",
                    mergeTags: {
                        street: {
                            name: "Indirizzo",
                            value: "{{address.street}}"
                        },
                        region: {
                            name: "Regione",
                            value: "{{address.region}}"
                        },
                        city: {
                            name: "Cittá",
                            value: "{{address.city}}"
                        },
                        province: {
                            name: "Provincia",
                            value: "{{address.province}}"
                        },
                        zip: {
                            name: "Cap",
                            value: "{{address.zip}}"
                        }
                    }
                },
                auto: {
                    name: "Veicolo",
                    mergeTags: {
                        plate: {
                            name: "Targa",
                            value: "{{car.plate}}"
                        },
                        km: {
                            name: "Km",
                            value: "{{car.km}}"
                        },
                        make: {
                            name: "Marca",
                            value: "{{car.make}}"
                        },
                        model: {
                            name: "Modello",
                            value: "{{car.model}}"
                        },
                        preparation: {
                            name: "Allestimento",
                            value: "{{car.preparation}}"
                        },
                    }
                },
                service: {
                    name: "Tagliando",
                    mergeTags: {
                        km: {
                            name: "Scadenza in km",
                            value: "{{service.km}}"
                        },
                        duration: {
                            name: "Scadenza in mesi",
                            value: "{{service.months}}"
                        },
                    }
                },
            }
        })

        // All properties starting with on[Name] are registered as event listeners.
        for (const [key, value] of Object.entries(this.props)) {
            if (/^on/.test(key) && key != 'onLoad') {
                this.addEventListener(key, value);
            }
        }

        this.loadDesign(this.props.initialValue);
    }

    registerCallback = (type, callback) => {
        unlayer.registerCallback(type, callback);
    }

    addEventListener = (type, callback) => {
        unlayer.addEventListener(type, callback);
    }

    loadDesign = (design) => {
        if (!design) return;
        unlayer.loadDesign(design);
    }

    loadTemplate = () => {
        unlayer.loadTemplate(this.props.templateId);
    }

    /* saveTemplate = () => {
        unlayer.saveTemplate(13162);
    } */

    saveDesign = (callback) => {
        unlayer.saveDesign(callback);
    }

    exportHtml = (callback) => {
        unlayer.exportHtml(callback);
    }

    setMergeTags = (mergeTags) => {
        unlayer.setMergeTags(mergeTags);
    }
}

export default EmailBuilder